//@ts-nocheck
import React, { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MainContainer from "./Main";
import PageLoader from "./PageLoader";
const Home = lazy(() => import("../../components/Home"))
const CreateEvent = lazy(() => import("../../components/Events/CreateEvent"));
const Events = lazy(() => import("../../components/Events/Events"));
const Artists = lazy(() => import("../../components/Artists/Artists"));
const CreateArtist = lazy(() => import("../../components/Artists/CreateArtist"));
const Organiser = lazy(() => import("../../components/Organiser/Organiser"));
const CreateOrganiser = lazy(() => import("../../components/Organiser/CreateOrganiser"));
const Venue = lazy(() => import("../../components/Venue/Venue"));
const CreateVenue = lazy(() => import("../../components/Venue/CreateVenue"));

export const GlobalRoutes = () => {
    return (
        <Routes>
            <Route element={<MainContainer />}>
                <Route
                    index
                    element={<Suspense fallback={<PageLoader />}><Home /></Suspense>}
                />
                <Route
                    path="events"
                    element={<Suspense fallback={<PageLoader />}><Events /></Suspense>}
                />
                <Route
                    path="/events/live"
                    element={<Suspense fallback={<PageLoader />}><Events /></Suspense>}
                />
                <Route
                    path="/events/draft"
                    element={<Suspense fallback={<PageLoader />}><Events /></Suspense>}
                />
                <Route
                    path="/events/create"
                    element={<Suspense fallback={<PageLoader />}><CreateEvent isEdit={false} /></Suspense>}
                />
                <Route
                    path="/events/edit"
                    element={<Suspense fallback={<PageLoader />}><CreateEvent isEdit={true} /></Suspense>}
                />
                <Route
                    path="artist"
                    element={<Suspense fallback={<PageLoader />}><Artists /></Suspense>}
                />
                <Route
                    path="/artist/create"
                    element={<Suspense fallback={<PageLoader />}><CreateArtist isEdit={false} /></Suspense>}
                />
                 <Route
                    path="/artist/edit"
                    element={<Suspense fallback={<PageLoader />}><CreateArtist isEdit={true} /></Suspense>}
                />
                <Route
                    path="organiser"
                    element={<Suspense fallback={<PageLoader />}><Organiser /></Suspense>}
                />                
                <Route
                    path="/organiser/create"
                    element={<Suspense fallback={<PageLoader />}><CreateOrganiser  isEdit={false} /></Suspense>}
                />
                <Route
                    path="/organiser/edit"
                    element={<Suspense fallback={<PageLoader />}><CreateOrganiser  isEdit={true} /></Suspense>}
                />
                <Route
                    path="venue"
                    element={<Suspense fallback={<PageLoader />}><Venue /></Suspense>}
                />
                <Route
                    path="/venue/create"
                    element={<Suspense fallback={<PageLoader />}><CreateVenue isEdit={false} /></Suspense>}
                />
                <Route
                    path="/venue/edit"
                    element={<Suspense fallback={<PageLoader />}><CreateVenue isEdit={true} /></Suspense>}
                />
                <Route
                    path="*"
                    element={<Navigate to="/" replace />}
                />
            </Route>
        </Routes>
    )
}
